import { X } from 'lucide-react';
import { Drawer } from 'vaul';
import type { WatchlistImportSummary } from '../types/api';

export function ImportResultSheet({ open, fileName, summary, desktop = false, onOpenChange }: {
  open: boolean;
  fileName: string;
  summary: WatchlistImportSummary | null;
  desktop?: boolean;
  onOpenChange(open: boolean): void;
}) {
  if (!summary) return null;

  const duplicatesSkipped = summary.duplicates_skipped ?? [];
  const unknownSkipped = summary.unknown_skipped ?? [];
  const inactiveSkipped = summary.inactive_skipped ?? [];
  const invalidTokens = summary.invalid_tokens ?? [];

  const content = (
    <>
      <div className="sheet-header">
        <strong>Import result</strong>
        <button type="button" className={desktop ? 'desktop-alarm-icon-button' : 'icon-button'} aria-label="Close import result" onClick={() => onOpenChange(false)}><X size={24} strokeWidth={1.9} /></button>
      </div>

      <div className="import-result-summary">
        <strong>{summary.symbols_added} symbols imported</strong>
        <span>{fileName}</span>
      </div>

      <div className="import-result-metrics">
        <span>Sections created: {summary.sections_created}</span>
        <span>Total tokens: {summary.total_tokens}</span>
        <span>Duplicates skipped: {duplicatesSkipped.length}</span>
        <span>Unknown skipped: {unknownSkipped.length}</span>
        <span>Inactive skipped: {inactiveSkipped.length}</span>
        <span>Invalid tokens: {invalidTokens.length}</span>
      </div>

      <SkippedTokenList title="Duplicates" values={duplicatesSkipped} />
      <SkippedTokenList title="Unknown symbols" values={unknownSkipped} />
      <SkippedTokenList title="Inactive symbols" values={inactiveSkipped} />
      <SkippedTokenList title="Invalid tokens" values={invalidTokens} />
    </>
  );

  if (desktop) {
    if (!open) return null;
    return (
      <div className="desktop-alarm-backdrop" onClick={() => onOpenChange(false)}>
        <section className="desktop-import-modal" aria-label="Import result" onClick={(event) => event.stopPropagation()}>
          {content}
        </section>
      </div>
    );
  }

  return (
    <Drawer.Root open={open} onOpenChange={onOpenChange}>
      <Drawer.Portal>
        <Drawer.Overlay className="drawer-overlay" />
        <Drawer.Content className="drawer-content import-result-sheet" aria-describedby={undefined}>
          <div className="sheet-handle" aria-hidden="true" />
          {content}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}

function SkippedTokenList({ title, values }: { title: string; values: string[] }) {
  if (values.length === 0) return null;

  return (
    <section className="import-result-section">
      <strong>{title}</strong>
      <div className="import-result-token-list">
        {values.map((value) => <span key={`${title}:${value}`}>{value}</span>)}
      </div>
    </section>
  );
}
